function togglePasswordVisibility(
    element = document,
    target = "customer-password"
) {
    const passwordInput = document.getElementById(target);
    const passwordIconEyeClosed = element.querySelector(".icon-eye-closed");
    const passwordIconEyeOpened = element.querySelector(".icon-eye-opened");

    if (passwordInput.type === "password") {
        passwordInput.type = "text";
        passwordIconEyeOpened.style.display = "none";
        passwordIconEyeClosed.style.display = "block";
    } else {
        passwordInput.type = "password";
        passwordIconEyeClosed.style.display = "none";
        passwordIconEyeOpened.style.display = "block";
    }
}
